export default {
  invoicePdfList: [],
  receiptPdfList: [],
};
